export default __webpack_public_path__ + "static/media/sbo-title-cn.bec8349c.webp";